<template>

    <SubHeader title="Fiche division" :breads="[ { name: 'Fiche division' }]" :action="{name:'Revenir sur la liste',to:'AdminConfigDivision'}" />
    <div class="row">
        <div class="col-md-12">
            <form @submit.prevent="handleSubmit(divisionShowItems)">
                <!-- @csrf -->

                <div class="row">
                    <div class="col-md-12">
                        <div class="card">

                            <div class="card-header card-header-content-md-between">
                                <h3 class="card-header-title">Détails</h3>
                                <small class="text-muted">Saisie des informations</small>
                            </div>
                            <div class="card-body">
                                <div class="mb-3">
                                    <label class="form-label" for="label">Libellé</label>
                                    <input type="text" name="label" id="label" class="form-control"
                                        placeholder="Division" v-model="divisionShowItems.label">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br><br>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <button type="submit" class="btn btn-primary">Modifier</button>&nbsp;
                                <button type="button" class="btn btn-danger mx-3">Annuler</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>
<script>

import SubHeader from "@/layouts/admin/SubHeader.vue"
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
    name: "AdminConfigShowDivision",
    components: {
        SubHeader
    },
    computed: {
        ...mapFields("division/show", {
            divisionShowItems: "item",
            divisionShowIsLoading: "isLoading",
            divisionShowIsSuccess: "isSuccess",
        }),
        ...mapFields("division/update", {
            isLoading: "isLoading",
            isSuccess: "isSuccess",
            isUpdated: "isUpdated",
            item: "item",
        })
    },
    methods: {
        ...mapActions({
            reset: "division/show/resetData",
            resetUpdate: "division/update/resetData",
            handleSubmit: "division/update/update",
            getDivision: "division/show/getOne",
        })
    },
    watch: {
        isUpdated(val){
            if(val){
                this.$router.push({name:'AdminConfigDivision'})
            }
        }
    },
    mounted() {
        this.getDivision(this.$route.params.id ?? 0)
    },
    unmounted() {
        this.reset()
        this.resetUpdate()
    }
}
</script>
